import {Box} from '@mui/material';
import {styled} from '@mui/system';

export const OutlineBox = styled(Box)({
	border: "1px solid #858fa5",
});
